import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { PatientDiaryEntry } from "../../../../../core/models/patient-diary-entry.model";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DateHelper } from "../../../../../core/helpers/date-helper";
import { ModalComponent } from "../../../../../shared/modal/modal.component";
import { EDiaryService } from "../../../../../core/services/e-diary.service";
import { AlertService } from "../../../../../shared/alert/alert.service";
import { MfaService } from "../../../../../core/services/mfa.service";
import { LogHelper } from "../../../../../core/helpers/log.helper";

@Component({
  selector: 'app-update-diary-entry-modal',
  templateUrl: './update-diary-entry-modal.component.html',
  styleUrl: './update-diary-entry-modal.component.scss'
})
export class UpdateDiaryEntryModalComponent {
  @ViewChild('modal') modal: ModalComponent;

  @Output('entryUpdated') entryUpdated = new EventEmitter();

  constructor(
    private _diaryService: EDiaryService,
    private _alertService: AlertService,
    private _mfaService: MfaService
  ) {}

  entry?: PatientDiaryEntry = null;
  isBusy = false;

  form: FormGroup = new FormGroup({
    pillsTaken: new FormControl<number>(0, [Validators.required, Validators.min(0)]),
    timeTaken: new FormControl<string>('', [Validators.required]),
    fasting: new FormControl<boolean>(false),
  });

  show(entry: PatientDiaryEntry) {
    this.entry = entry;

    const timeStr = entry.timeTakenMinutes ? DateHelper.convertMinutesTo24HourTime(entry.timeTakenMinutes) : DateHelper.convertMinutesTo24HourTime(entry.dailyDoseReminderTimeMinutes);

    this.form.patchValue({
      pillsTaken: entry.pillsTaken ? entry.pillsTaken : entry.dosage,
      fasting: entry.fasting,
      timeTaken: timeStr
    });

    this.modal.show();
  }

  hide() {
    this.form.reset();
    this.entry = null;
    this.modal.hide();
  }

  onSubmitForm() {
    if (!this.form.valid)
      return;

    this.isBusy = true;

    this._mfaService.authenticateWithMfa().subscribe({
      next: (success) => {
        if (!success) {
          this.isBusy = false;
          this._alertService.showWarningAlert('User authentication failed. Changes cannot be saved');
          return;
        }

        this.updateEntry();
      },
      error: (err) => {
        LogHelper.log(err);
        this.isBusy = false;
        this._alertService.showWarningAlert('User authentication failed. Changes cannot be saved');
      }
    });
  }

  private updateEntry() {
    this._diaryService.updateMazeDiaryEntry(this.entry.id, this.form.value.fasting, DateHelper.convert24HourTimeToMinutes(this.form.value.timeTaken), this.form.value.pillsTaken).subscribe({
      next: () => {
        this.hide();
        this.isBusy = false;
        this.entryUpdated.emit();
        this._alertService.showSuccessAlert('The diary entry has been updated.');
      },
      error: (err) => {
        LogHelper.log(err);
        this.isBusy = false;
        this._alertService.showErrorAlert(err);
      }
    });
  }
}
